export default "__VITE_ASSET__7P6bTChj__"